import React from 'react';
import "./title.scss";

const Title = ({ title, breadcrumb }) => {
    return (
        <div className="title">
            {title}
            {breadcrumb && breadcrumb.length > 0 ? (
                <div className="breadcrumb">
                    {breadcrumb.map((bread,index) => {
                        return `${bread} ${breadcrumb.length > index+1?" > ":""}`;
                    })}
                </div>
            ) : null}
        </div>

    )
}

export default Title;